const { DateTime } = require("luxon")
const { configuracion_horas, configuracion_fechas } = require("./dates")
const { timezone, urlapi } = require("../backend/data")

const configuracion_fechas_cortas = { month: 'short', day: 'numeric', year: 'numeric' }

const control = {}
const formatearMinutos = (value) => {
  if(!isNaN(parseInt(value))){
    if(parseInt(value) < 10) return `0${value}`
  }
  return value
}

control.formatYMD = (fecha) => {
  let date = false
  if(fecha){
      if(typeof fecha === "string"){
          date = fecha
      } else {
          date = fecha.toISOString()
      }
  } else {
      date = DateTime.now().setZone(timezone).toJSDate().toISOString()
  }
  const fecha_sin_ofset = date.substring(0,23)
  const parseado = DateTime.fromISO(fecha_sin_ofset).toFormat("yyyy-MM-dd")
  return parseado
}

control.dateToYMDFormat = (fecha) => {
  if(fecha){
      if(typeof fecha === "string"){
          return DateTime.fromISO(fecha).toFormat("yyyy-MM-dd")
      } else {
          return DateTime.fromJSDate(fecha).toFormat("yyyy-MM-dd")
      }
  } else {
      return DateTime.now().toFormat("yyyy-MM-dd")
  }
}

control.duracionTiempoString = (minutos) => {
  const hours = Math.floor(minutos / 60);
  const remainingMinutes = minutos % 60;
  if(!hours) return `${remainingMinutes.toFixed(0)} Mins.`

  return `${hours} Hrs. ${remainingMinutes.toFixed(0)} Mins.`
}

const agregarCero = (value) => {
  if(value < 10) return `0${value}`
  return value
}

control.agregarCero = agregarCero

control.fechaUTCATiempo = (fecha, lang) => {
  if(!fecha) return ''
  const date2 = DateTime.fromISO(fecha).toJSDate()
  return `${date2.getHours()}:${agregarCero(date2.getMinutes())} Hrs.`
}

control.fechaUTCATexto = (fecha, lang) => {
  if(!fecha) return ''
  const date = new Date(fecha)
  const date2 = DateTime.fromISO(fecha)
  return `${date.toLocaleDateString('es-ES', configuracion_fechas )} · ${date2.hour}:${formatearMinutos(date2.minute)} Hrs.`
}

control.fechaATexto = (fecha, lang) => {
  const date = new Date(fecha)
  return `${date.toLocaleDateString('es-ES', configuracion_fechas )} · ${date.toLocaleTimeString('en-US', configuracion_horas)}`
}

control.validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

control.ordenarProductos = (registros) => {
  const nuevos = registros.sort((a,b)=> {
    const posicion = typeof a.orden !== 'undefined' ? a.orden : 99999999
    return posicion > b.orden ? 1 : -1
  })
  return nuevos
}

control.showAmmount = (ammount) => {
  return Intl.NumberFormat("es-ES").format(ammount)
}

control.limpiarRut = (rut) => {
    if(!rut) return rut
    const dato = rut.toString().replace('.','')
    if(!dato) return rut
    const dato2 = dato.replace('.','')
    if(!dato2) return dato
    const dato3 = dato2.replace('.','')
    if(!dato3) return dato2
    return dato3
}

control.checkForDuplicatesEmails = (email,lista) => {
    const buscar = lista.filter(user => user.email === email)
    if(buscar.length > 0) return true
    return false
}

control.sliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}

control.corregirTelefono = (num) => {

    if(!num){
      return false
    }

    const digito = num.toString()

    const longitud = digito.length

    if(longitud === 0){
      return false
    }
    const numero = digito.replace('+56', '56')
    if(longitud === 9){
      return `56${numero}`
    } else if(longitud === 8){
      return `569${numero}`
    }

    return numero
}

control.montoMoneda = (monto) => {
  return Intl.NumberFormat("es-ES").format(monto)
}

const dv = function(T) {
  var M = 0,
      S = 1;
  for (; T; T = Math.floor(T / 10))
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
  return S ? S - 1 : 'k';
}

control.validarRut = function(rutCompleto) {
  if (!/^[0-9]+-[0-9kK]{1}$/.test(rutCompleto))
      return false;
  var tmp = rutCompleto.split('-');
  var digv = tmp[1];
  var rut = tmp[0];
  if (digv == 'K') digv = 'k';
  return (dv(rut) == digv);
}

control.formatoRut = (value) => {
  return value
  .replace(/[^0-9\dkK]/g, '')
    .replace( /^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4')
}

control.formatoMoneda = value => {
  return Intl.NumberFormat("en-DE").format(Math.round(value))
}

control.formatearRUTChileno = (rut) => {
  /// Eliminar puntos y guión del RUT (dejar solo dígitos y K)
 const rutLimpio = rut.replace(/[.-]/g, "").toUpperCase();

 if (!/^[0-9]+[0-9K]?$/.test(rutLimpio)) {
   // El RUT contiene caracteres inválidos
   return rut;
 }

 const rutSinDigitoVerificador = rutLimpio.slice(0, -1);
 const digitoVerificador = rutLimpio.slice(-1);

 let rutFormateado = "";
 let contador = 0;

 // Agregar los puntos al RUT, evitando número negativo en el primer dígito
 for (let i = rutSinDigitoVerificador.length - 1; i >= 0; i--) {
   rutFormateado = rutSinDigitoVerificador.charAt(i) + rutFormateado;
   contador++;
   if (contador % 3 === 0 && i !== 0) {
     rutFormateado = `.${rutFormateado}`;
   }
 }

 // Agregar el guión y el dígito verificador si el RUT tiene dos caracteres o más
 if (rutFormateado.length > 1) {
   rutFormateado += "-";
 }
 rutFormateado += digitoVerificador;

 return rutFormateado;
 };

 control.limpiarStringNumeros = (cadena) => {
  const regex = /\D/g
  return cadena.replace(regex, '');
};

control.fechaATextoSimple = (fecha, lang) => {
  if(!fecha) return ''
  if(typeof fecha !== "string") fecha = DateTime.fromJSDate(fecha).toISO()
  const date2 = DateTime.fromISO(fecha.substring(0,23)).toJSDate()
  const date = new Date(date2)
  return `${date2.toLocaleDateString('es-ES', configuracion_fechas )}`
}

control.fechaATextoSimpleCorto = (fecha, lang) => {
  if(!fecha) return ''
  if(typeof fecha !== "string") fecha = DateTime.fromJSDate(fecha).toISO()
  const date2 = DateTime.fromISO(fecha.substring(0,23)).toJSDate()
  const date = new Date(date2)
  return `${date2.toLocaleDateString('es-ES', configuracion_fechas_cortas )}`
}


control.calcularPorcentaje = (montoTotal, montoActual) => {
  const porcentaje = (montoActual / montoTotal) * 100;
  return porcentaje;
}

control.urlByPaymentGateway = (name, username, email, ammount) => {
  const data = {
      transbank: {
          url: `${urlapi}/payments/transbank/oneclick/create?username=${username}&email=${email}`,
          method: "GET"
      },
      mercadopago: {
          url: `${urlapi}/payments/mercadopago/checkoutpro/create`,
          method: "POST",
          body: JSON.stringify({
              ammount: parseInt(ammount)
          })
      },
  }
  return data[name]
}

control.calcularPorcentajeSobreCantidad = (montoTotal, montoActual) => {
  const porcentaje = (montoActual / montoTotal) * 100;
  return !isNaN(porcentaje) ? porcentaje : 0
}

module.exports = control